import { useEffect, useRef } from 'react'
import Player from 'video.js/dist/types/player'

import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import { useMinBandwidth } from './hooks/useMinBandwidth'

export const VideoJS = props => {
  const videoRef = useRef(null)
  const playerRef = useRef<Player>(null)
  const { options, onReady, onPlayingCB, onErrorCB } = props

  useMinBandwidth(playerRef.current, onErrorCB)

  useEffect(() => {
    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode.
      const videoElement = document.createElement('video-js')

      videoElement.classList.add('vjs-big-play-centered')
      videoRef.current.appendChild(videoElement)

      playerRef.current = videojs(videoElement, options, (playerInstance: Player) => {
        videojs.log('player is ready')
        onReady?.(playerInstance)
      })
    } else {
      playerRef.current.autoplay(true)
      void playerRef.current.play()
    }
  }, [options, videoRef])

  // Dispose the Video.js player when the functional component unmounts
  useEffect(() => {
    const player = playerRef.current

    if (typeof player.on === 'function') {
      player.on('playing', () => {
        onPlayingCB()
      })

      player.on('error', () => {
        console.log('coming here error error')
        onErrorCB() //Gives MEDIA_ERR_SRC_NOT_SUPPORTED error
      })
    }

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose()
        playerRef.current = null
      }
    }
  }, [playerRef])

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        overflow: 'hidden',
      }}
      data-vjs-player
      id="test1"
    >
      <div
        style={{
          height: '100%',
          width: '100%',
          transform: props.transformScale,
        }}
        ref={videoRef}
      />
    </div>
  )
}
